import { AsyncPipe, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { Router } from '@angular/router'
import { TabletIdentifierService } from '@app-services/tablet-identifier/tablet-identifier.service'
import { TabletsService } from '@app-services/tablets/tablets.service'
import { Observable } from 'rxjs'
import { ButtonDirective, HeadingDirective, ParagraphDirective } from '../../domains/ui/directives'
import { TabletMessageFragment, TabletStatusEnum } from '../../generated/graphql'

@Component({
    selector: 'app-onboarding-page',
    imports: [
        HeadingDirective,
        AsyncPipe,
        MatIcon,
        ParagraphDirective,
        ButtonDirective,
        NgIf,
    ],
    templateUrl: './onboarding-page.component.html',
    standalone: true,
    styleUrl: './onboarding-page.component.scss',
})
export class OnboardingPageComponent implements OnInit {

    public tabletIdentifier$: Observable<string | null>
    public currentTabletMessage$: Observable<TabletMessageFragment | null>
    public error: string | null

    constructor(
        private tabletIdentifierService: TabletIdentifierService,
        private tabletsService: TabletsService,
        private router: Router,
    ) {
    }

    public ngOnInit(): void {
        this.tabletIdentifier$ = this.tabletIdentifierService.identifier$
        this.currentTabletMessage$ = this.tabletsService.currentTabletMessage$

    }

    public async finalizeConfiguration() {
        // Verify if everything is configured properly
        const identifier = this.tabletIdentifierService.getIdentifier()
        if (! identifier) return
        const tabletStatus = await this.tabletsService.getTabletStatus(identifier)

        if (tabletStatus === TabletStatusEnum.Registered) {
            await this.router.navigate(['/'])
            this.tabletsService.resetTabletMessage()
        } else {
            this.error = 'Er is iets mis gegaan tijdens de configuratie, probeer het opnieuw.'
        }
    }

    public regenerateIdentifier() {
        this.tabletsService.resetTabletMessage()
        this.error = ''
        this.tabletIdentifierService.regenerateIdentifier()
    }

}
